module.exports = __webpack_public_path__ + "img/img1.1989af7b.jpg";